import * as React from "react";
import { cn } from "../lib/utils.js";

/** Visually hidden until focused; jumps to the main landmark. */
function SkipLink({ className, ...props }: React.ComponentProps<"a">) {
  return (
    <a
      data-slot="skip-link"
      className={cn(
        "sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-background focus:px-4 focus:py-3 focus:text-foreground focus:shadow",
        className,
      )}
      {...props}
    />
  );
}

export { SkipLink };
